import { captureException } from "@sentry/browser";
import { Component } from "react";

import ServerError from "@/pages/errors/server-error";

interface ErrorBoundaryProps {
  children: React.ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  // biome-ignore lint/suspicious/noExplicitAny: legacy
  constructor(props: any) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  // biome-ignore lint/suspicious/noExplicitAny: legacy
  componentDidCatch(error: any, info: any) {
    captureException(error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return <ServerError />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
